import React from 'react';
import './SectionTitle.css';

const SectionTitle = ({title, backgroundImage, id}) => {
    return (
        <div className={`section-title ${backgroundImage}`} id={id}>
            <h2>{title}</h2>
        </div>
    )
};

export default SectionTitle;